module.exports = __webpack_public_path__ + "img/side-banner_live.68e3ea9e.jpg";